import React from 'react';
import { TbBowlSpoon, TbCheck, TbCheckupList } from 'react-icons/tb';
interface BreadcrumbOrderProps {
    currentStep: number;
    disabled: boolean;
}

const BreadcrumbOrder = ({ currentStep, disabled }: BreadcrumbOrderProps) => {
    const defaultStepClass = 'relative flex items-center justify-start md:justify-center gap-1 px-2 pl-4 md:px-4 py-2';
    const currentStepClass = `${defaultStepClass} text-gray-800 bg-white`;
    const stepOkClass = `${currentStepClass}`;
    const waitingClass = `${defaultStepClass} text-gray-400`;
    const ping = <div className="animate-ping absolute z-5 rounded-full w-12 h-12 bg-white"></div>;

    interface StepProps {
        name: string;
        description: string;
        icon: any;
    }
    const steps = [
        // { name: 'Enviado', description: 'Em análise', icon: <TbShoppingBagSearch /> },
        // { name: 'Aceito', description: 'Tudo certo', icon: <TbShoppingBagCheck /> },
        { name: 'Montagem', description: 'Preparando', icon: <TbBowlSpoon /> },
        { name: 'Liberado', description: 'Pronto para entrega', icon: <TbCheckupList /> },
        { name: 'Entregue', description: 'Finalizado', icon: <TbCheck /> },
    ]

    const divider = <>
        <span className={`absolute top-1/2 -left-2.5 size-4 -translate-y-1/2 rotate-45 ${currentStep > 0 && 'bg-red-400 hidden'}`}></span>
        <span className={`absolute top-1/2 -right-2 size-4 -translate-y-1/2 rotate-45 ${currentStep < 2 && 'bg-white'}`}></span>
    </>

    const getCurrentClass = (index: number) => {
        return index < currentStep ? stepOkClass : index === currentStep ? currentStepClass : waitingClass;
    }

  return (
    <div className={`w-full md:max-w-max ${disabled ? 'grayscale' : ''}`}>
        <ol className={`grid grid-cols-${steps.length} overflow-hidden rounded-lg text-sm text-gray-500 bg-gray-100 shadow-md shadow-gray-200 ring-1 ring-gray-100 divide-x divide-white`}>
            {steps.map((step: StepProps, index: number) => (
                <li className={ getCurrentClass(index) } key={index}>
                    {(currentStep === index) && divider}
                    <div className="relative flex items-center justify-center">
                        <div className={`text-lg md:text-2xl transition-all ease-in-out ${(index <= currentStep) && 'z-10 text-shopfood-success'}`}>
                            { step.icon }
                        </div>
                        {(currentStep === index && !disabled) && ping}
                    </div>
                    <p className="leading-none">
                        <strong className="block font-semibold">{ step.name }</strong>
                        <small className="hidden md:block mt-0.5 opacity-60">{ step.description }</small>
                    </p>
                </li>
            ))}
        </ol>
    </div>
  )
}

export default BreadcrumbOrder;